import React from 'react';
import Button from '@material-ui/core/Button';
import Snackbar from '@material-ui/core/Snackbar';
import TextField from "@material-ui/core/TextField/TextField";
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import firebase from "./fire";

class PositionedSnackbar extends React.Component {
  state = {
    open: true,
    vertical: 'top',
    horizontal: 'center',
  };

  handleClick = state => () => {
    this.setState({ open: true, ...state });
  };



  handleClose = () => {
    this.setState({ open: false });
  };

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
    });

  };

  handlePostButtonClick = () => {
    firebase.database().ref('signups/').push({
      email: this.state.email,
    });
    this.setState({
      email: "",
    });
  }
  render() {
    return (
      <div>

        <Snackbar

          anchorOrigin={{ vertical:"bottom", horizontal: "right" }}
          open={this.state.open}
          onClose={this.handleClose}
          ContentProps={{
            'aria-describedby': 'message-id',
              "style":  {background: "#ccc", color: "black"}

          }}
          message={
            <div >
              <h2 >Sign up for even more problems via email!</h2>
              <h4 >We promise you to not spam!</h4>
              <TextField
                id="name"
                label="Email Address"
                value={this.state.email}
                onChange={this.handleChange('email')}
                margin="normal"
              />
              <Button  variant="contained" color="primary" onClick={()=> this.handlePostButtonClick()}>
                Sign up

              </Button>
            </div>
          }
          action={[

            <IconButton
              key="close"
              aria-label="Close"
              color="inherit"
              onClick={this.handleClose}
            >
              <CloseIcon />
            </IconButton>,
          ]}
        />
      </div>
    );
  }
}

export default PositionedSnackbar;


// WEBPACK FOOTER //
// ./src/Snackbar.js